import { Copy } from 'lucide-react';

import { ActionButton } from '@/_containers/actions';
import { snackbar, useCopyToClipboard } from '@/_shared';

import { DeleteButton } from '../../../buttons';

export function PhoneNumberControls({
  onDelete,
  number,
  confirmDelete,
  isEditing = false,
}: {
  onDelete: () => void;
  number?: string;
  confirmDelete?: boolean;
  isEditing?: boolean;
}) {
  const { copy } = useCopyToClipboard();

  return (
    <div className="absolute top-3 right-0 flex flex-1 justify-end gap-0.5">
      {number && (
        <ActionButton
          title="Copy Phone Number"
          icon={Copy}
          onClick={() => {
            copy(number);
            snackbar.success(`${number} has been copied to clipboard`);
          }}
        />
      )}
      {isEditing && (
        <DeleteButton
          title="Remove Phone Number?"
          text="The Phone Number record will not be deleted; only its association will be removed."
          aria-label="Remove phone number"
          tooltipTitle="Remove Phone Number"
          size="sm"
          type="icon"
          confirmDelete={confirmDelete}
          callback={onDelete}
        />
      )}
    </div>
  );
}
